var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleTapFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 511.852 511.852",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M201.118 212.953v-29.998c-34.163-17.022-52.118-55.318-43.351-92.467s41.948-63.378 80.118-63.33c38.169.048 71.285 26.36 79.959 63.53s-9.376 75.422-43.582 92.358v4.745a35.96 35.96 0 0 1 38.83 1.262c35.568-33.809 44.328-87.14 21.445-130.55-22.884-43.41-71.833-66.321-119.826-56.083s-83.332 51.128-86.509 100.098 26.584 94.083 72.852 110.435zM246.897 493.566a9.143 9.143 0 0 0 0 18.286h146.286a9.143 9.143 0 0 0 0-18.286z",
    fill: "#6c757d",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.687 338.009a82.916 82.916 0 0 1 54.217 25.975c4.498 5.44 6.117 7.735 7.515 9.737a276.189 276.189 0 0 0 24.393 27.785 160.084 160.084 0 0 0 26.432 23.259 92.497 92.497 0 0 1 31.735 50.514h141.202c.603 0 1.17.137 1.765.174 2.651-4.571 5.486-9.289 8.914-14.391 16.75-25.097 16.75-41.445 16.75-77.211V246.709c0-10.099-8.187-18.286-18.286-18.286s-18.286 8.187-18.286 18.286v27.429a9.143 9.143 0 0 1-18.286 0v-45.714c0-10.099-8.187-18.286-18.286-18.286s-18.286 8.187-18.286 18.286v36.571a9.143 9.143 0 0 1-18.286 0V219.28c0-10.099-8.187-18.286-18.286-18.286s-18.286 8.187-18.286 18.286v36.571a9.143 9.143 0 0 1-18.286 0V111.12c.258-10.127-7.299-18.758-17.371-19.84a18.286 18.286 0 0 0-19.2 18.285l-.091 201.143a18.22 18.22 0 0 1-9.39 15.954 18.414 18.414 0 0 1-18.688-.53c-27.803-17.719-49.298-26.843-82.56-24.585-9.58.413-17.214 8.157-17.49 17.742-.274 9.585 6.901 17.756 16.441 18.72z",
    fill: "#6c757d",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.754 109.566c0-35.346-28.654-64-64-64s-64 28.654-64 64a63.432 63.432 0 0 0 27.429 52.279v-52.279a36.792 36.792 0 0 1 11.41-26.514 36.103 36.103 0 0 1 27.099-10.057c19.83 1.509 35.03 18.242 34.633 38.126v50.798a63.657 63.657 0 0 0 27.429-52.353z",
    fill: "#6c757d",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleTapFull);
export default __webpack_public_path__ + "static/media/double-tap-full.54b42dcc95414317fa180319b1a1d742.svg";
export { ForwardRef as ReactComponent };